export const profileData = [
  {
    id: 1,
    img: "https://i.imgur.com/qPP5pwh.jpg",
    name: "Eric Albert",
    age: 26,
  },
  {
    id: 2,
    img: "https://i.imgur.com/KH3ept3.jpg",
    name: "Escanor Light",
    age: 22,
  },
  {
    id: 3,
    img: "https://i.imgur.com/zwJnrzw.jpg",
    name: "Shaun Kinston",
    age: 24,
  },
  {
    id: 4,
    img: "https://i.imgur.com/xnnEJO9.jpg",
    name: "Ronald McArthur",
    age: 24,
  },
  {
    id: 5,
    img: "https://i.imgur.com/yEK4pmg.jpg",
    name: "Deither ",
    age: 24,
  },
];
